/**
 *
 * HayyaBuild JavaScript
 *
 * File name : hayyabuild.js
 *
 *
 */

import waves from './modules/waves.js'

if ( typeof window === "undefined" || ! window.document ) {
    ( () => {
        throw new Error("HayyaBuild requires a window with a document");
    })()
}

( function() {
    "use strict";

    // const basic                 = require( './basic' ).default
    const helper                = require( './helper' ).default
    // const hayyaBuildMenu        = require( './modules/menu' ).default
    // const fixedDiv              = require( './modules/fixed_div' ).default
    const alertBlock            = require( './modules/alert' ).default
    const menu                  = require( './modules/menu' ).default
    const stickybox             = require( './modules/stickybox' ).default
    const hayyabuildEvents      = require( './modules/super_events' ).default
    const footerAnimation       = require( './modules/footer_animation' ).default
    const goTop                 = require( './modules/go_top' ).default
    const smothScrollTo         = require( './modules/go_up_down' ).default

    class hayyaBuild {

        constructor() {

            // HayyaBuild version
            this.version = '4.0'

            // HayyaBuild description
            this.description = 'HayyaBuild allows you to build unlimited headers,',
                               'pages and footers for your WordPress website without the needs for writing any code.'

            // this.basic = basic

            this.stickybox = stickybox

            this.goTop = goTop // Go Up link

            this.menu = menu // menu block

            this.smothScrollTo = smothScrollTo  // for goTop and goDown

            this.hayyabuildEvents = hayyabuildEvents // superEvents

            // this.smothScrolling = smothScrolling; // smothScrolling:

            this.footerAnimation = footerAnimation // TODO: remove this

            // this.fixedDiv = fixedDiv // Fixed Box Block :

            this.alertBlock = alertBlock // Alert Block:
            
            // this.hayyaBuildMenu = hayyaBuildMenu // hayyaBuildMenu:

            // this.googleMap = googleMap( HBmap ); // Google Map

            this._initializer();
        }

        // initalizer
        _initializer() {

            // this.basic()
            // this.smothScrolling() // when click in anchor link
            document.querySelector('.wp-block-hayyabuild-goup') && this.goTop()
            document.querySelector('.wp-block-hayyabuild-stickybox') && this.stickybox()
            document.querySelector('.wp-block-hayyabuild-godown > a, .wp-block-hayyabuild-goup > a') && this.smothScrollTo() // for goTop and goDown
            // document.querySelector('.hb-menu') && this.hayyaBuildMenu()

            document.querySelector('.wp-block-hayyabuild-menu') && this.menu()

            helper.footer && this.footerAnimation()
            // document.querySelector('.hb-scrolleffects') && this.superEvents()
            document.querySelector('.hb-scrolleffects') && this.hayyabuildEvents()
            // document.querySelector('.hb-fixeddiv') && this.fixedDiv()
            document.querySelector('.wp-block-hayyabuild-alert__close') && this.alertBlock()

            // Waves init
            waves.init()
        } // init:

    }

    new hayyaBuild()

})();
